class GoogleAdsTracker
{
    static adwordsId_addToBasket = 'AW-11470722288/OwtuCNG2_boZEPCp1d0q';
    static adwordsId_beginCheckout = 'AW-11470722288/1pUYCMuSprsZEPCp1d0q';
    static currency = 'GBP';

    start()
    {
        // set up event listeners
        this.eventlistener_addToBasket();
        this.eventlistener_beginCheckout();
    }

    eventlistener_addToBasket()
    {
        var addToBasketButton = document.querySelector('#addToCart');
        if (addToBasketButton != null)
        {
            var context = this;
            addToBasketButton.addEventListener('click', function(){
            
                var currencyString = document.querySelector('#productPrice').innerHTML;
                var cleanedString = currencyString.replace(/[^0-9.]/g, '');
                var numericValue = parseFloat(cleanedString);
                context.addToBasketConversion(numericValue);
            });
        }
    }

    eventlistener_beginCheckout()
    {
        var checkoutButtons = document.querySelectorAll('button[name="checkout"]');
        var context = this;
        checkoutButtons.forEach(function(checkoutButton){
            checkoutButton.addEventListener('click', function(){
                var currencyString = document.querySelector('.total-price.money').innerHTML;
                var cleanedString = currencyString.replace(/[^0-9.]/g, '');
                var numericValue = parseFloat(cleanedString);
                context.beginCheckoutConversion(numericValue);
            });
        });
        
    }

    addToBasketConversion(basketItemPrice)
    {
        gtag('event', 'conversion', {
            'send_to': GoogleAdsTracker.adwordsId_addToBasket,
            'value': basketItemPrice,
            'currency': GoogleAdsTracker.currency
        });
    }

    beginCheckoutConversion(basketTotalPrice)
    {
        gtag('event', 'conversion', {
            'send_to': GoogleAdsTracker.adwordsId_beginCheckout,
            'value': basketTotalPrice,
            'currency': GoogleAdsTracker.currency
        });
    }
}

var googleAdsTracker;
document.addEventListener('DOMContentLoaded', function(){
    googleAdsTracker = new GoogleAdsTracker();
    googleAdsTracker.start();
});


